import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-inventory-resources';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(private fabricService: FabricService) {}

  getInventoryByInstance(id): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_mgmt_instances_id_inventory', {id});
  }

  putInventoryByInstance(id): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'put_mgmt_instances_id_inventory', {id});
  }

}